import type { FC } from 'react';
import LoadingOverlay from '@components/LoadingOverlay';
import { SectionModalController } from '@ContractBuilder/modules/navigation/modules/section-modal';
import type { Attachment } from '@ContractBuilder/types';

import { NavigationSectionsList } from '../components/NavigationSectionsList';
import { NavigationDragProvider } from '../context/navigation-drag-context';
import { useNavigation } from '../context/use-navigation';
import type { NavItem } from '../types';

interface NavigationProps {
  activeSectionId?: string;
  getShouldDisableOperations?: (item: NavItem) => boolean;
  hasAttachments?: boolean;
  isDragDisabled: boolean;
  sections: NavItem[];
  attachments?: Attachment[];
}

const NavigationContent: FC<{ hasAttachments: boolean }> = ({ hasAttachments }) => {
  const { isLoading } = useNavigation();

  return (
    <div
      className={
        hasAttachments ? 'flex max-h-[65%] flex-col overflow-hidden' : 'flex max-h-full flex-col overflow-hidden'
      }
    >
      <SectionModalController />
      <div className="flex-1 overflow-y-auto py-3">
        <LoadingOverlay active={isLoading} className="!fixed" />
        <NavigationSectionsList />
      </div>
    </div>
  );
};

export const Navigation: FC<NavigationProps> = ({
  activeSectionId,
  getShouldDisableOperations = () => false,
  hasAttachments = false,
  isDragDisabled,
  sections,
  attachments,
}) => {
  return (
    <NavigationDragProvider
      navItems={sections}
      attachments={attachments}
      activeSectionId={activeSectionId}
      getShouldDisableOperations={getShouldDisableOperations}
      isDragDisabled={isDragDisabled}
    >
      <NavigationContent hasAttachments={hasAttachments} />
    </NavigationDragProvider>
  );
};
